import { Pipe, PipeTransform } from '@angular/core';
import { VorgangsTyp } from 'src/app/domain/model/vorgangsTyp';

@Pipe({
    name: 'aufgabeTypeReadable',
    standalone: false,
})
export class AufgabeTypeReadablePipe implements PipeTransform {

    transform(value: VorgangsTyp): any {
        switch (value) {
            case VorgangsTyp.AUFGABE:
                return 'Aufgabe';
            case VorgangsTyp.INFORMATION:
                return 'Information';
            case VorgangsTyp.TERMIN:
                return 'Termin';
            case VorgangsTyp.GESAMTLAST:
                return 'Gesamtlast';
            case VorgangsTyp.ABWURFPUNKTE_INFORMATION:
                return 'Abwurfpunkte (Information)';
            case VorgangsTyp.ABWURFPUNKTE_AUFGABE:
                return 'Abwurfpunkte (Aufgabe)';
            default:
                return 'Unbekannter Aufgabentyp';
        }
    }
}
